<ng-container *ngrxLet="ccActionButtonsViewModel$; let value;">
  @if (value?.ccLocation && value?.ccMenuRowViewModel) {
    <div class="flex">
      <!--claim/undo claim button-->
      <button mat-icon-button
        class="ml-2"
            [disabled]="!value.ccMenuRowViewModel.ccLocationGroup ||
                  (!value.ccLocation.isClaimCandidate && !value.ccLocation.isUnclaimCandidate)
                    || value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId]?.ongoingCcOperation === ccOperations.CLAIM
                    || value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId]?.ongoingCcOperation === ccOperations.UNDO_CLAIM
                    || value.ccMenuRowViewModel.ccLocationsLoading"
        [class.text-blue-40]="value.ccLocation.isClaimedByTheFocusedLocation"
            (click)="value.ccLocation.isClaimCandidate ?
                    startCcOperation(value.ccMenuRowViewModel.focusedLocationId, value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId], ccOperations.CLAIM) :
                    startCcOperation(value.ccMenuRowViewModel.focusedLocationId, value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId], ccOperations.UNDO_CLAIM)"
        appGtagEvent
            action="{{ value.ccLocation.isClaimCandidate ?
                    'Claim location' : 'Un-claim location' }}"
        trackOn="click"
        category="C&C actions [overhaul]">
        @if (!(value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId]?.ongoingCcOperation === ccOperations.CLAIM ||
          value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId]?.ongoingCcOperation === ccOperations.UNDO_CLAIM ||
          value.ccMenuRowViewModel.ccLocationsLoading)) {
          <mat-icon id="claim-icon"
                [fontSet]="value.ccLocation.isClaimed || value.ccLocation.isClaimedByTheFocusedLocation ?
                        'material-icons' : 'material-icons-outlined'"
            [matTooltip]="getClaimButtonTooltip(value.ccLocation, value.ccMenuRowViewModel.ccLocationGroup)"
                [svgIcon]="value.ccLocation.isClaimed || value.ccLocation.isClaimedByTheFocusedLocation ?
                        'verified_user' : 'verified_user_outlined'">
          </mat-icon>
        }
        @if (value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId]?.ongoingCcOperation === ccOperations.CLAIM ||
          value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId]?.ongoingCcOperation === ccOperations.UNDO_CLAIM) {
          <mat-spinner
          [diameter]="24"></mat-spinner>
        }
        @if (value.ccMenuRowViewModel.ccLocationsLoading) {
          <ngx-skeleton-loader count="1"
            [theme]="{ height: '30px', width: '30px', marginTop: '15px' }"
            animation="pulse"
          ></ngx-skeleton-loader>
        }
      </button>
      <!--toggle-as-duplicate button-->
      <button mat-icon-button
        class="mr-2"
            [disabled]="!value.ccMenuRowViewModel.ccLocationGroup ||
                  (!value.ccLocation.isMarkAsDuplicateCandidate && !value.ccLocation.isMarkedAsDuplicate) ||
                    value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId]?.ongoingCcOperation === ccOperations.MARK_AS_DUPE ||
                    value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId]?.ongoingCcOperation === ccOperations.UNDO_MARK_AS_DUPE ||
                    value.ccMenuRowViewModel.ccLocationsLoading"
        [class.text-orange-20]="value.ccLocation.isMarkedAsDuplicateForFocusedLocation"
            (click)="value.ccLocation.isMarkAsDuplicateCandidate ?
                    startCcOperation(value.ccMenuRowViewModel.focusedLocationId, value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId], ccOperations.MARK_AS_DUPE) :
                    startCcOperation(value.ccMenuRowViewModel.focusedLocationId, value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId], ccOperations.UNDO_MARK_AS_DUPE)"
        appGtagEvent
        trackOn="click"
            action="{{ value.ccLocation.isMarkAsDuplicateCandidate ?
                    'Mark location as duplicate' : 'Unmark location as duplicate' }}"
        category="C&C actions [overhaul]">
        @if (!(value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId]?.ongoingCcOperation === ccOperations.MARK_AS_DUPE ||
          value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId]?.ongoingCcOperation === ccOperations.UNDO_MARK_AS_DUPE ||
          value.ccMenuRowViewModel.ccLocationsLoading)) {
          <mat-icon id="duplicate-icon"
                [svgIcon]="value.ccLocation.isMarkedAsDuplicate ?
                        'mark_duplicate_full' :
                        'mark_duplicate'"
            [matTooltip]="getDuplicateButtonTooltip(value.ccLocation, value.ccMenuRowViewModel.ccLocationGroup)">
          </mat-icon>
        }
        @if (value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId]?.ongoingCcOperation === ccOperations.MARK_AS_DUPE ||
          value.ccMenuRowViewModel.ccRowSettingsDictionary[value.ccLocation.placeId]?.ongoingCcOperation === ccOperations.UNDO_MARK_AS_DUPE) {
          <mat-spinner
          [diameter]="24"></mat-spinner>
        }
        @if (value.ccMenuRowViewModel.ccLocationsLoading) {
          <ngx-skeleton-loader count="1"
            [theme]="{ height: '30px', width: '30px', marginTop: '15px' }"
            animation="pulse"
          ></ngx-skeleton-loader>
        }
      </button>
    </div>
  }
</ng-container>
